'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { useLocale, useTranslations } from 'next-intl';
import { type FC, useCallback, useState } from 'react';
import { Modal } from '@/utils/antd-imports';
import useBreakpoints from '../../../hooks/useBreakpoints';
import type { LocaleType } from '../../../i18n/config';
import { routing } from '../../../i18n/routing';
interface LanguageSelectorProps {
  /**
   * Вариант отображения селектора
   */
  variant?: 'modal' | 'dropdown';
  /**
   * Дополнительные CSS классы
   */
  className?: string;
}

/**
 * Современный компонент для переключения языков
 * Использует next-intl для корректной навигации и локализации
 *
 * @example
 * <LanguageSelector variant="modal" />
 */
export const LanguageSelector: FC<LanguageSelectorProps> = t0 => {
  const $ = _c(57);
  const {
    variant: t1,
    className: t2
  } = t0;
  const variant = t1 === undefined ? "modal" : t1;
  const className = t2 === undefined ? "" : t2;
  const [isOpen, setIsOpen] = useState(false);
  const locale = useLocale() as LocaleType;
  const router = useRouter();
  const pathname = usePathname();
  const {
    lg
  } = useBreakpoints();
  const t = useTranslations("common.languages");
  const tSelector = useTranslations("LanguageSelect");
  let T0;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== className || $[1] !== isOpen || $[2] !== lg || $[3] !== locale || $[4] !== pathname || $[5] !== router || $[6] !== t || $[7] !== tSelector || $[8] !== variant) {
    t14 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t15;
      if ($[22] !== t) {
        t15 = code => ({
          code,
          name: t(code as any)
        });
        $[22] = t;
        $[23] = t15;
      } else {
        t15 = $[23];
      }
      const availableLocales = routing.locales.map(t15);
      let t16;
      if ($[24] !== pathname || $[25] !== router) {
        t16 = newLocale => {
          setIsOpen(false);
          const pathnameWithoutLocale = pathname.replace(/^\/[a-z]{2}/, "") || "/";
          const newPath = `/${newLocale}${pathnameWithoutLocale}`;
          router.push(newPath);
        };
        $[24] = pathname;
        $[25] = router;
        $[26] = t16;
      } else {
        t16 = $[26];
      }
      const handleLocaleChange = t16;
      let t17;
      if ($[27] !== className || $[28] !== locale || $[29] !== t || $[30] !== tSelector) {
        t17 = () => <button onClick={() => setIsOpen(true)} className={`btn-free  flex cursor-pointer items-center justify-center text-[18px] text-white outline-none lg:m-0 ${className}`} aria-label={tSelector("Title")}>{t(locale as any)}<Image alt="arrow" className="ml-2" src="/icons/arrow.svg" height={6} width={9} /></button>;
        $[27] = className;
        $[28] = locale;
        $[29] = t;
        $[30] = tSelector;
        $[31] = t17;
      } else {
        t17 = $[31];
      }
      const renderTriggerButton = t17;
      const renderLanguageList = () => <div className="w-full"><h2 className="mb-[40px] font-secondary uppercase leading-md lg:text-[30px]">{tSelector("Title")}</h2><div className="-mb-[20px] flex flex-col flex-wrap lg:-mx-[50px] lg:flex-row lg:pl-[50px]">{availableLocales.map(t18 => {
            const {
              code: code_0,
              name
            } = t18;
            return <div key={code_0} className="mb-[20px] text-[18px] lg:w-[33.333%]"><button onClick={() => handleLocaleChange(code_0)} className={`transition-colors hover:text-[#3D63E8] ${locale === code_0 ? "text-[#3D63E8]" : ""}`} disabled={locale === code_0} aria-label={`Switch to ${name}`}>{name}</button></div>;
          })}</div></div>;
      if (variant === "dropdown") {
        let t19;
        if ($[32] !== renderTriggerButton) {
          t19 = renderTriggerButton();
          $[32] = renderTriggerButton;
          $[33] = t19;
        } else {
          t19 = $[33];
        }
        t14 = t19;
        break bb0;
      }
      if ($[34] !== renderTriggerButton) {
        t13 = renderTriggerButton();
        $[34] = renderTriggerButton;
        $[35] = t13;
      } else {
        t13 = $[35];
      }
      T0 = Modal;
      t3 = isOpen;
      t4 = lg;
      if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = () => setIsOpen(false);
        $[36] = t5;
      } else {
        t5 = $[36];
      }
      t6 = true;
      t7 = null;
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <span className="flex items-center justify-center"><Image src="/icons/close-bold-black.svg" width={24} height={24} alt="Close" /></span>;
        $[37] = t8;
      } else {
        t8 = $[37];
      }
      t9 = lg ? "956px" : "100vw";
      if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
          top: 0,
          maxWidth: "100vw",
          margin: 0,
          paddingBottom: 0
        };
        $[38] = t10;
      } else {
        t10 = $[38];
      }
      const t19 = lg ? "auto" : "100vh";
      const t20 = lg ? "70px 120px" : "48px 16px";
      if ($[39] !== t19 || $[40] !== t20) {
        t11 = {
          body: {
            display: "flex",
            flexDirection: "column",
            height: "auto",
            minHeight: t19,
            padding: t20
          }
        };
        $[39] = t19;
        $[40] = t20;
        $[41] = t11;
      } else {
        t11 = $[41];
      }
      t12 = renderLanguageList();
    }
    $[0] = className;
    $[1] = isOpen;
    $[2] = lg;
    $[3] = locale;
    $[4] = pathname;
    $[5] = router;
    $[6] = t;
    $[7] = tSelector;
    $[8] = variant;
    $[9] = T0;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  if (t14 !== Symbol.for("react.early_return_sentinel")) {
    return t14;
  }
  let t15;
  if ($[42] !== T0 || $[43] !== t10 || $[44] !== t11 || $[45] !== t12 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5 || $[49] !== t6 || $[50] !== t7 || $[51] !== t8 || $[52] !== t9) {
    t15 = <T0 open={t3} centered={t4} onCancel={t5} destroyOnHidden={t6} footer={t7} closeIcon={t8} width={t9} style={t10} styles={t11}>{t12}</T0>;
    $[42] = T0;
    $[43] = t10;
    $[44] = t11;
    $[45] = t12;
    $[46] = t3;
    $[47] = t4;
    $[48] = t5;
    $[49] = t6;
    $[50] = t7;
    $[51] = t8;
    $[52] = t9;
    $[53] = t15;
  } else {
    t15 = $[53];
  }
  let t16;
  if ($[54] !== t13 || $[55] !== t15) {
    t16 = <>{t13}{t15}</>;
    $[54] = t13;
    $[55] = t15;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  return t16;
};
export type { LanguageSelectorProps };